import { useState, useEffect } from 'react';

export const CycleWord = ({ words = [], interval = 2400 }) => {
  const [i, setI] = useState(0);
  const [prev, setPrev] = useState(-1);
  useEffect(() => {
    const t = setInterval(() => {
      setI(curr => {
        setPrev(curr);
        return (curr + 1) % words.length;
      });
    }, interval);
    return () => clearInterval(t);
  }, [words, interval]);

  const longest = words.reduce((a, b) => (b.length > a.length ? b : a), '');

  return (
    <span className="cycle-word">
      <span className="cycle-word-measure">{longest}</span>
      <span className="cycle-word-stack" aria-live="polite">
        {words.map((w, idx) => {
          const cls = idx === i ? 'is-on' : (idx === prev ? 'is-out' : '');
          return <span key={idx} className={cls}>{w}</span>;
        })}
      </span>
    </span>
  );
};
